const parents = [
    {
        id: 1, title: 'menu.parent_dashboard', icon: 'fa fa-home', href: 'dashboard',
    },
    {
        id: 2, title: 'menu.parent_reports', icon: 'fa fa-users', href: 'reports',
    },
    {
        id: 3, title: 'menu.parent_programs', icon: 'fa fa-money', href: 'programs',
    },
    // {
    //   id: 4, title: 'menu.introduction', icon: 'fa fa-newspaper-o', href: 'introduction',
    // },
/*  {
    id: 4, title: 'menu.parent_support', icon: 'fa fa-newspaper-o', href: 'support',
  }, */
];


const DashboardMenu = [
    {
        href: 'dashboard',
        title: 'menu.dash_dashboard',
        icon: 'el-icon-s-home',
        parent: 1,
    },
];

const ReportsMenu = [
    {
        href: 'achievement',
        title: 'menu.reports_summary',
        icon: 'fa fa-area-chart',
        parent: 2,
    },
    {
        href: 'media',
        title: 'menu.reports_media',
        icon: 'el-icon-files',
        parent: 2,
    },
    {
        href: 'financial',
        title: 'menu.reports_financial',
        icon: 'el-icon-s-finance',
        parent: 2,
    },
    {
        href: 'tierreport',
        title: 'menu.reports_subtier',
        icon: 'fa fa-area-chart',
        parent: 2,
    },
    {
        href: 'players',
        title: 'menu.players',
        icon: 'fa fa-users',
        parent: 2,
    },
    {
        href: 'rewards',
        title: 'menu.reports_rewards',
        icon: 'el-icon-trophy-1',
        parent: 2,
    },
    {
        href: 'transactions',
        title: 'menu.reports_transactions',
        icon: 'el-icon-s-order',
        parent: 2,
        visible: true,
    },
];

const ProgramsMenu = [
    {
        href: 'advertisement',
        title: 'menu.programs_media',
        icon: 'fa fa-picture-o',
        parent: 3,
    },
    {
        href: 'campaign',
        title: 'menu.programs_campaign',
        icon: 'fa fa-flag',
        parent: 3,
    },
/*  {
    href: 'referral',
    title: 'menu.programs_referral',
    icon: 'el-icon-link',
    parent: 3,
  }, */
];

const SupportsMenu = [
    {
        href: 'beginners',
        title: 'introduction.beginners_guide',
        icon: 'fa fa-newspaper-o',
        parent: 4,
    },
];

const subItems = [...DashboardMenu, ...ReportsMenu, ...ProgramsMenu, ...SupportsMenu];

export { parents, subItems };
